/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
export enum RepositoryTab {
    CHART = 'Chart',
    IMAGE = 'Image'
}

export enum IsImageInUse {
    USED = '1',
    UN_USED = '0'
}

export enum ContainerServiceStatus {
    Running = 'Running',
    Stopped = 'Stopped'
}

/**
 * 预检查包类型
 */
export enum CmoPackageTypeE {
    /**
     * VM镜像包
     */
    VM_IMAGE_PACKAGE = 18,
}
